export default "__VITE_PUBLIC_ASSET__fb2561f5__"